import NavigationZone from "./NavigationZone";
import React, { useState, useEffect, useRef } from "react";
import { faTwitter, faInstagram} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import React, { useRef } from "react";
import { useLocation } from "react-router-dom";

import { useNavigate } from "react-router-dom";



const WorkSpace = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [isShowing, setIsShowing] = useState(false);
    const [isShowing2, setIsShowing2] = useState(false);
    const [isShowing3, setIsShowing3] = useState(false);
    const [isShowing4, setIsShowing4] = useState(false);




    const betterRef = useRef(null);
    const betterRef2 = useRef(null);
    const betterRef3 = useRef(null);
    const betterRef4 = useRef(null);
    const betterRef5 = useRef(null);

  const { pathname } = useLocation();

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100); // Delay ensures it's applied after navigation

  }, [pathname]);

    useEffect(() => {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setIsShowing4(true);
            observer.disconnect(); // Stop observing once visible
          }
        },
        { threshold: 0.1 } // Adjust threshold as needed
      );
  
      if (betterRef5.current) {
        observer.observe(betterRef5.current);
      }
  
      return () => observer.disconnect();
    }, []);

    
    useEffect(() => {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setIsShowing3(true);
            observer.disconnect(); // Stop observing once visible
          }
        },
        { threshold: 0.1 } // Adjust threshold as needed
      );
  
      if (betterRef4.current) {
        observer.observe(betterRef4.current);
      }
  
      return () => observer.disconnect();
    }, []);

    useEffect(() => {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setIsShowing2(true);
            observer.disconnect(); // Stop observing once visible
          }
        },
        { threshold: 0.1 } // Adjust threshold as needed
      );
  
      if (betterRef3.current) {
        observer.observe(betterRef3.current);
      }
  
      return () => observer.disconnect();
    }, []);

    useEffect(() => {
        const observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              setIsShowing(true);
              observer.disconnect(); // Stop observing once visible
            }
          },
          { threshold: 0.1 } // Adjust threshold as needed
        );
    
        if (betterRef2.current) {
          observer.observe(betterRef2.current);
        }
    
        return () => observer.disconnect();
      }, []);



    useEffect(() => {
        const observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              setIsVisible(true);
              observer.disconnect(); // Stop observing once visible
            }
          },
          { threshold: 0.1 } // Adjust threshold as needed
        );
    
        if (betterRef.current) {
          observer.observe(betterRef.current);
        }
    
        return () => observer.disconnect();
      }, []);


      const videoRef = useRef(null); // Reference to the video element
      let lastTap = 0; // Track last tap for double-tap detection
    
      // Function to toggle full screen
      const toggleFullScreen = () => {
        const video = videoRef.current;
        
        if (!document.fullscreenElement) {
          if (video.requestFullscreen) {
            video.requestFullscreen();
          } else if (video.mozRequestFullScreen) { 
            video.mozRequestFullScreen();
          } else if (video.webkitRequestFullscreen) { 
            video.webkitRequestFullscreen();
          } else if (video.msRequestFullscreen) { 
            video.msRequestFullscreen();
          }
        } else {
          if (document.exitFullscreen) {
            document.exitFullscreen();
          }
        }
      };
    
      // Function to handle double-tap on mobile
      const handleTouchEnd = () => {
        let currentTime = new Date().getTime();
        let tapLength = currentTime - lastTap;
    
        if (tapLength < 300 && tapLength > 0) {
          toggleFullScreen();
        }
        
        lastTap = currentTime;
      };


      const videoRef2 = useRef(null); // Reference to the video element
      // let lastTap = 0; // Track last tap for double-tap detection
    
      // Function to toggle full screen
      const toggleFullScreen2 = () => {
        const video = videoRef2.current;
        
        if (!document.fullscreenElement) {
          if (video.requestFullscreen) {
            video.requestFullscreen();
          } else if (video.mozRequestFullScreen) { 
            video.mozRequestFullScreen();
          } else if (video.webkitRequestFullscreen) { 
            video.webkitRequestFullscreen();
          } else if (video.msRequestFullscreen) { 
            video.msRequestFullscreen();
          }
        } else {
          if (document.exitFullscreen) {
            document.exitFullscreen();
          }
        }
      };
    
      // Function to handle double-tap on mobile
      const handleTouchEnd2 = () => {
        let currentTime = new Date().getTime();
        let tapLength = currentTime - lastTap;
    
        if (tapLength < 300 && tapLength > 0) {
          toggleFullScreen();
        }
        
        lastTap = currentTime;
      };

      const videoRef3 = useRef(null); // Reference to the video element
      // let lastTap = 0; // Track last tap for double-tap detection
    
      // Function to toggle full screen
      const toggleFullScreen3 = () => {
        const video = videoRef3.current;
        
        if (!document.fullscreenElement) {
          if (video.requestFullscreen) {
            video.requestFullscreen();
          } else if (video.mozRequestFullScreen) { 
            video.mozRequestFullScreen();
          } else if (video.webkitRequestFullscreen) { 
            video.webkitRequestFullscreen();
          } else if (video.msRequestFullscreen) { 
            video.msRequestFullscreen();
          }
        } else {
          if (document.exitFullscreen) {
            document.exitFullscreen();
          }
        }
      };
    
      // Function to handle double-tap on mobile
      const handleTouchEnd3 = () => {
        let currentTime = new Date().getTime();
        let tapLength = currentTime - lastTap;
    
        if (tapLength < 300 && tapLength > 0) {
          toggleFullScreen();
        }
        
        lastTap = currentTime;
      };

          const getInThere = useNavigate()
          const goHomePage = useNavigate()
          
          const homePage = () => {
            goHomePage('/')
            // setIsAnimating(true)
          
          }
      
      const getIn = () => {
        getInThere('/getInTouch')
            }
    


    return (  
        <div className="work-Space">
            <NavigationZone />
            <div className="workPositioning">

                <div className="purpose">
                    <h1 className="inAction">PURPOSE IN  ACTION</h1>
                    <h1 className="ourWork">Our Work</h1>
                    <p>My projects evolve as I grow, reflecting the depth of my experience and adaptability. With each new challenge, I incorporate fresh ideas, modern technologies, and refined techniques, ensuring my work remains impactful, user-focused, and cutting-edge</p>
                </div>

                <div className="purpose2">
                    <div className="fix1">  
                        <img src="screen1.png" className="screen1"/>  
                    </div>
                    <div className="fix2">
                    <img src="screen10.png" className="screen1"/>  

                    </div>
                </div>
              </div>
   <div className="allWhite">
    <div className="exp">
        <div className="ones">
        <h1>2</h1>
        <h2>+</h2>
        </div>
      <p>YEARS EXPERIENCE</p>
    </div>
    <div className="exp2">
    <div className="ones">
        <h1>100</h1>
        <h2>%</h2>
        </div>
      <p className="goodNess">GOODNESS</p>
    </div>
    <div className="exp">
    <div className="ones">
        <h1>1</h1>
        <h2></h2>
        </div>
      <p>DEDICATED DEVELOPER </p>
    </div>
    <div className="exp2">
    <div className="ones">
        <h1>2024</h1>
        <h2></h2>
        </div>
      <p>ESTABLISHED SINCE </p>
    </div>
   </div>

   <div className="allGreen">
    <h1 className="xplore">Explore Projects</h1>
    <div ref={betterRef}
    className={`dem ${isVisible ? 'fade-in2' : 'hidden'}`}
    >
        <div className="inDem">
          

            <div className="picIndem">


            <video playsInline controls
            className='vid'     
            autoPlay 
              loop 
              muted 
              ref={videoRef}
              onDoubleClick={toggleFullScreen} // Double-click for desktop
              onTouchEnd={handleTouchEnd}
              >
        <source src="screen2.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>


            </div>
            <div className="picIndem2">
                <h1>Wears and Jewelries</h1>
                <p className="aboutWeb1">A meaningful wears brand web for local stores to improve their local root and increase their reachability to global customers just with their mobile phones</p>
                <p className="standout">Standout in packaging products</p>
            </div>


        </div>
    </div>

    <div ref={betterRef2}
              className={`dem2 ${isShowing ? 'fade-in2' : 'hidden'}`}
    
    >
        <div className="inDem">
        <div 
             className="picIndem"

        >
        <video playsInline controls
        className='vid'     
            autoPlay 
              loop 
              muted
                            ref={videoRef2}
              onDoubleClick={toggleFullScreen2} // Double-click for desktop
              onTouchEnd={handleTouchEnd2} >
        <source src="screen3.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
        </div>

        
            <div className="picIndem2">
                <h1>Ordering Pizza </h1>
                <p className="aboutWeb1">Designed a local pizza ordering web platform that simplifies the process for users to explore, customize, and order pizzas seamlessly. The project showcases an intuitive interface and efficient functionality, providing food brands with a blueprint to enhance customer engagement and streamline online orders.</p>
                <p className="standout2">Standout in displaying products</p>
            </div>
        </div>
    </div>



    <div ref={betterRef3}
              className={`dem2 ${isShowing2 ? 'fade-in2' : 'hidden'}`}
    
    >
        <div className="inDem">
        <div 
             className="picIndem"

        >
        <video playsInline controls
        className='vid'     
            autoPlay 
            loop 
            muted
                          ref={videoRef3}
            onDoubleClick={toggleFullScreen3} // Double-click for desktop
            onTouchEnd={handleTouchEnd3} >
        <source src="screen4.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
        </div>
            <div className="picIndem3">
                <h1>New Notes </h1>
                <p className="aboutWeb1">
                At the start of my journey to becoming a better developer, I created a Notes Project, this project allows users to create and save notes along with pictures, helping to organize thoughts visually and textually. Additionally, it features a to-do list for tracking tasks efficiently. This project not only helped me improve my skills in development but also underscored the importance of building tools that simplify everyday life.</p>
                {/* <p className="standout3">Standout in displaying products</p> */}
            </div>
        </div>
    </div>


    <div ref={betterRef4}
              className={`dem2 ${isShowing3 ? 'fade-in2' : 'hidden'}`}
    
    >
        <div className="inDem">
        <div 
             className="picIndem"

        >
        <video playsInline controls
        className='vid'     
            autoPlay 
            loop 
            muted
                          ref={videoRef3}
            onDoubleClick={toggleFullScreen3} // Double-click for desktop
            onTouchEnd={handleTouchEnd3} >
        <source src="ani.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
        </div>
            <div className="picIndem3">
                <h1>Love Quote </h1>
                <p className="aboutWeb1">
                My Love Quote & Message Web generates personalized love quotes with the user's name included. It fetches unlimited romantic messages from an API, updating dynamically with each click. The Web features a romantic design, and future updates may include social sharing and message saving.</p>
                {/* <p className="standout3">Standout in displaying products</p> */}
            </div>
        </div>
    </div>

    <div 
    ref={betterRef5}
    className={`bottomWork ${isShowing4 ? 'fade-in2' : 'hidden'}`}
    >
    <div className="buttomAll">
    <h1>Ready to bring goodness to the table?</h1>
    <div className="getIN2">
        <div className="getIN" onClick={getIn}>
            <p>Get In Touch</p>
        </div>
        </div>
    </div>
    </div>

   <div className="bottomNav">
<p onClick={homePage} className='homeBtn'>Home </p>
<p className='homeBtn'>Projects </p>
<p className='homeBtn'>Contact </p>
   </div>

<div className="styleLongLIne">
<p className="longLine"></p>
</div>

<div className="belowLIne">
  <h1>Lit_Codes1 | Est 2024</h1>
  <div className="mySocials">
  <div className="faceBook2">
    <a href="https://x.com/lit_webdev" target="_blank"  className="ig2">
    <FontAwesomeIcon icon={faTwitter} />

    </a>
  </div>
  <div className="faceBook2">
    <a href='https://www.instagram.com/heis__lit/' target="_blank" className="ig2">
    <FontAwesomeIcon icon={faInstagram} />

    </a>
  </div>
  </div>
</div>

   </div>

            
        </div>
    );
}
 
export default WorkSpace;